import React from "react"
import { Badge as ChakraBadge } from "@chakra-ui/react"

const Badge = (props) => <ChakraBadge px={4} borderWidth={1} borderRadius="md" fontSize="sm" textTransform="none" {...props} />

export default Badge
